import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "../form-elements/form-elements.scss";
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "40px",
    borderRadius: "4px",
    color: "#24272b",
    border: "1px solid #e0e0e0",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "white" : "#292a2a",
    fontSize: "1rem",
    backgroundColor: state.isSelected ? "#0047ba" : "initial",
    zIndex: 2,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#9c9c9c",
    fontSize: "1rem",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "1rem",
    top: "50%",
  }),
  Input: (provided) => ({
    ...provided,
    display: "none",
  }),
};

const MultiSelect = ({
  name,
  placeholder,
  data,
  returnValue,
  disabled,
  defaultValueArr,
  multiSelectVal,
  isSearchable,
  onChangeHandler
}) => {

  const [tooltipStates, setTooltipStates] = useState({});

  // Create an array of ref objects to reference each Tooltip component
  const tooltipRefs = useRef([]);

  // Initialize refs based on the number of tooltips
  useEffect(() => {
    if (data) tooltipRefs.current = new Array(data.length).fill(null).map(() => React.createRef());
  }, [data]);

  const optionsFunction = (multiSelectVal) => {
    if (name === 'diverseSpendSelectedList') {
      let multiSelectValTemp = multiSelectVal.map((data, index) => ({
        label: labelWithToolTip(data, index),
        value: data.value,
        originalLabel: data.label,
        id: data.id
      }));
      return multiSelectValTemp;
    } else {
      return multiSelectVal;
    }
  };

  const labelWithToolTip = (data, index) => {
    return (
      <p style={{ whiteSpace: 'nowrap', margin: '0px' }}>
        {data.label}
        <span>
          {iIcon(data.description, index)}
        </span>
      </p>
    );
  };

  const iIcon = (infoTxt, index) => {
    // Use the tooltipStates object to manage tooltip state
    const tooltipState = tooltipStates[index] || false;
    return (
      <>
        <img
          id={`Tooltip${index}`}
          ref={tooltipRefs.current[index]}
          src={information}
          style={{ paddingLeft: '5px', position: 'relative', top: '-1px', }}
          onClick={(e) => handleOptionClick(e, data[index])}
          onMouseEnter={() => handleTooltipToggle(index, true)}
          onMouseLeave={() => handleTooltipToggle(index, false)}
        />
        <Tooltip
          placement="right"
          isOpen={tooltipState}
          target={tooltipRefs.current[index]}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };

  // Function to toggle tooltip state
  const handleTooltipToggle = (index, isOpen) => {
    setTooltipStates({
      ...tooltipStates,
      [index]: isOpen,
    });
  };

  // Function to handle option click and select an option
  const handleOptionClick = (e, selectedOption) => {
    e.stopPropagation(); // Prevent the Select dropdown from closing
    const newMultiSelectVal = [...multiSelectVal, selectedOption];
    onChangeHandler(newMultiSelectVal);

    // Hide the tooltip when an option is selected
    setTooltipStates({
      ...tooltipStates,
      [data.indexOf(selectedOption)]: false,
    });
  };

  return (
    <div>
      <Select
        value={multiSelectVal}
        closeMenuOnSelect={false}
        defaultValue={defaultValueArr}
        isMulti
        placeholder={placeholder}
        options={(data && data.length !== 0 && data[0].value !== "") ? optionsFunction(data) : []}
        className="basic-multi-select"
        classNamePrefix="select"
        isSearchable={isSearchable}
        isDisabled={disabled}
        noOptionsMessage={() => "No records"}
        isClearable={true}
        onChange={(data, index) => {
          if (name === 'scheduledPostStatusFilter' || name === 'orderStatus' || returnValue === 'true') {
            onChangeHandler(data)
          } else if (name === 'diverseSpendSelectedList') {
            let tempData = data?.map(dataVal => (
              {
                label: dataVal.originalLabel ? dataVal.originalLabel : dataVal.label,
                value: dataVal.value,
                id: dataVal.id
              }
            ))
            onChangeHandler(tempData || [])
          }
        }}
      />
    </div>
  );
};

export default MultiSelect;
